import React from 'react'
import PropTypes from 'prop-types'

import Col from 'component/utils/Col'
import Row from 'component/utils/Row'

const Title = ({
  handleSideFilterMenuCollapseChange = () => {},
  sideFilterVisible = false,
  translate = () => {},
}) => (
  <Row>
    <Col xs={12}>
      {sideFilterVisible && (
        <Col xs={3}>
          <p className='title start-left'>{translate('mobile.filters')}</p>
        </Col>
      )}
      <Col xs={9}>
        <button
          className={`filter-button ${
            sideFilterVisible ? '' : 'margin-left'
          } title`}
          onClick={() => handleSideFilterMenuCollapseChange(!sideFilterVisible)}
        >
          <i
            className={`glyph glyph-double-arrow-${
              sideFilterVisible ? 'left' : 'right'
            } glyph-grey icon-size`}
          />

          {translate('mobile.report')}
        </button>
      </Col>
    </Col>
  </Row>
)

Title.propTypes = {
  handleSideFilterMenuCollapseChange: PropTypes.func,
  sideFilterVisible: PropTypes.bool,
  translate: PropTypes.func,
}

export default Title
